/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./EventGroupActions',
	'../../../../app/nls/StringResources'
], function(EventGroupActions, stringResources) {

	class LinkEventGroupAction extends EventGroupActions {
		constructor({ features }) {
			super({ features: features });
			if(features) {
				features.ContentActions.registerProvider('linkFilterGroup', this.getAPI());
				this._icons = features.Icons;
			}
		}

		getContentActionList(idList) {
			if(this._isAvailable(idList)) {
				return [{
					name: 'linkFilterGroup',
					label: stringResources.get('toolbarActionLinkFilterGroup'),
					icon: this._icons.getIcon('link').id,
					type: 'NextView',
					order: 2,
					disabled: this.isDisabled.bind(this, idList),
					viewModule: 'dashboard-core/js/app/ui/dialogs/FilterGroupsDialog',
					viewOptions: {
						height: 140,
						width: 180,
						labels: false,
						idList: idList,
						controller: this
					},
					update: true
				}];
			} else {
				return [];
			}
		}

		isDisabled(idList) {
			if (this._isStaticWidget(idList)) {
				return true;
			}
			if(this.getNumberOfGroups(idList) < 2){
				return true;
			}
			return false;
		}

		getGroups(idList) {
			if (this._isStaticWidget(idList)) {
				return [];
			}
			let pageid = this._getPageId(idList);
			let groups = this.eventGroups.getGroupIdsOnPage(pageid);
			/*
			 * return the array of group ids for the "add to group" function. If the selection contains only 1 distinct group,
			 * then that group index should not be in the list of possible groups to be added to.
			 */
			let distinctGroupIdsInSelection = this._getDistinctGroupIdsInSelection(idList);
			//remove the group id from the list if the selection only contains 1 distinct group
			if (distinctGroupIdsInSelection.length === 1){
				groups = groups.filter(function(value) {
					return (value !== distinctGroupIdsInSelection[0]);
				});
				return groups;
			}
			return groups;
		}
	}
	return LinkEventGroupAction;
});
